import { render, staticRenderFns } from "./MiddleTwo.vue?vue&type=template&id=422b2a16&scoped=true&"
import script from "./MiddleTwo.vue?vue&type=script&lang=js&"
export * from "./MiddleTwo.vue?vue&type=script&lang=js&"
import style0 from "./MiddleTwo.vue?vue&type=style&index=0&id=422b2a16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b2a16",
  null
  
)

export default component.exports